"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giustino": {
    "81643223": [{
      "hkey": "b601edf8",
      "slug": "selci-lama",
      "name": "Selci-Lama",
      "primary": true,
      "skipSearch": false
    }],
    "lama": [{
      "hkey": "b601edf8",
      "slug": "selci-lama",
      "name": "Selci-Lama",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giustino"
    }],
    "773ff2dc": [{
      "hkey": "b601edf8",
      "slug": "selci-lama",
      "name": "Selci-Lama",
      "primary": true,
      "skipSearch": false
    }],
    "selci": [{
      "hkey": "b601edf8",
      "slug": "selci-lama",
      "name": "Selci-Lama",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6c169d66": [{
      "hkey": "ae14d77f",
      "slug": "renzetti",
      "name": "Renzetti",
      "primary": true,
      "skipSearch": false
    }],
    "uselle-renzetti": [{
      "hkey": "ae14d77f",
      "slug": "renzetti",
      "name": "Renzetti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;